<template>

        <v-card>
            <v-card-title
                    class="v-card__title--primary primary white--text"

            >
                <h3>Delete {{title}}</h3>
            </v-card-title>

            <v-card-text>
                Are you sure you want to delete {{title}}
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        color="primary"
                        arge round flat
                        @click="$emit('closeDialog')"
                >
                    Cancel
                </v-btn>
                <v-btn
                        color="error"
                        arge round
                        @click="$emit('onDelete')"
                >
                    Delete
                </v-btn>
            </v-card-actions>
        </v-card>

</template>

<script>
    export default {
        name: "deleteDialog",
        props: {
            title: {
                type: String,
                default: ()=> {
                    return  'Group'
                }
            }
        }
    }
</script>

<style scoped>

</style>